import type { TranslationCatalog } from "../TranslationManager";

export const ko: TranslationCatalog = {
  "labels.cardNumber": "카드 번호",
  "labels.expirationDate": "만료일",
  "labels.cvc": "보안 코드",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "카드 번호가 유효하지 않습니다.",
  "errors.invalidExpiryDate": "카드 만료일이 유효하지 않습니다.",
  "errors.invalidCvc": "카드 보안 코드가 유효하지 않습니다.",
  "errors.incompleteCardNumber": "카드 번호가 불완전합니다.",
  "errors.incompleteExpiryDate": "카드 만료일이 불완전합니다.",
  "errors.incompleteCvc": "카드 보안 코드가 불완전합니다.",
  "errors.expiredCard": "카드가 만료되었습니다.",
  "aria.cardNumber": "카드 번호",
  "aria.expirationDate": "만료일",
  "aria.cvc": "보안 코드",
  "aria.cardInput": "카드 정보",
};
